import React from 'react';
import { CodeEditorField } from '@dopomogai/ui';

interface OverlaysPanelProps {
  overlays: object | null;
}

export const OverlaysPanel: React.FC<OverlaysPanelProps> = ({ overlays }) => {
  return (
    <div className="h-full overflow-y-auto p-4">
      {overlays ? (
        <CodeEditorField
          value={JSON.stringify(overlays, null, 2)}
          language="json"
          readOnly
          theme="light"
          onChange={() => {}}
          showCopyButton
        />
      ) : (
        <div className="text-sm text-slate-500">
          No overlay data sent for the last turn. Send a message to see the context and prompt override.
        </div>
      )}
    </div>
  );
};